export const REPLACEMENT_SOURCE_NAME = 'simplr-replacement-api';
